document.getElementById('sort-high-to-low').addEventListener('click', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', 'price-descending');
    window.location.href = url.href;
});

document.getElementById('sort-low-to-high').addEventListener('click', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', 'price-ascending');
    window.location.href = url.href;
});

document.addEventListener('DOMContentLoaded', function() {
    var urlParams = new URLSearchParams(window.location.search);
    var sortOrder = urlParams.get('sort_by');
    if (sortOrder === 'price-descending') {
        document.getElementById('sort-high-to-low').classList.add('active');
    } else if (sortOrder === 'price-ascending') {
        document.getElementById('sort-low-to-high').classList.add('active');
    }
});